'use client';

import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Column, Spinner } from '@viewup/ui';
import { AuthBox } from 'app/_components/AuthBox';
import { PopupModal } from 'app/_components/PopupModal';
import jwtDecode from 'jwt-decode';
import { Suspense, useEffect } from 'react';
import { EarnedRanking } from '../EarnedRanking';
import { EventBanner } from '../EventBanner';
import { Footer } from '../Footer';
import { NewViewing } from '../NewViewing';
import { RenewalNoticeModal, useRenewalNotice } from '../RenewalNoticeModal';
import { ViewingMenus } from '../ViewingMenus';
import { ViewupTips } from '../ViewupTips';
import { ViewupUsage } from '../ViewupUsage';
import { usePopupLists } from './usePopupLists';

export const MainClientPage = () => {
  const { accessToken } = useTokenStore();
  const popupLists = usePopupLists();
  const {
    isOpen: isRenewalNoticeOpen,
    isChecked: isRenewalNoticeChecked,
    close: closeRenewalNotice,
    hideToday: hideRenewalNoticeToday,
    start: startRenewalApp,
    variant: renewalNoticeVariant,
  } = useRenewalNotice();

  // GA를 위한 dataLayer 설정
  useEffect(() => {
    if (!accessToken) return;

    try {
      const userUuid = jwtDecode<{ userUuid: string }>(accessToken)?.userUuid;

      if (!userUuid) return;

      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        gtm: {
          user_id: userUuid,
        },
        user_id: userUuid,
        user_uuid: userUuid,
      });
    } catch (_e) {
      //
    }
  }, [accessToken]);

  return (
    <Column height='100%' justifyContent='space-between'>
      <Suspense fallback={<Spinner variant='bar' />}>
        <Column>
          <Column bgColor='bg.disabledLight'>
            <AuthBox />
            <ViewingMenus />
          </Column>
          <Column bgColor='bg.primary' gap={24} pb={48} pt={24} px={24}>
            <EventBanner />
            <NewViewing />
            <EarnedRanking />
            <ViewupUsage />
            <ViewupTips />
          </Column>
          <Footer />
          {/* 두 모달이 겹치지 않도록 리뉴얼 안내가 우선 — 닫은 뒤에야 이벤트 팝업이 마운트된다. */}
          <RenewalNoticeModal
            isOpen={isRenewalNoticeOpen}
            onClickStart={startRenewalApp}
            onClose={closeRenewalNotice}
            onHideToday={hideRenewalNoticeToday}
            variant={renewalNoticeVariant}
          />
          {isRenewalNoticeChecked && !isRenewalNoticeOpen && <PopupModal items={popupLists} />}
        </Column>
      </Suspense>
    </Column>
  );
};
